export class Owner {
    _id: String;
    name: String;

    loadOwnerFromServer(r: any) {
        if (r._id)
            this._id = r._id;

        if (r.name)
            this.name = r.name;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/Owner.model.ts